import Vue from 'vue'
import parser from 'ua-parser-js'
import {serv, paymentStatus} from '@/api/config'
import store from '@/api/store'

const ua = parser()
export default new Vue({
  data: {
    isStandalone: !!process.env.VUE_APP_STANDALONE,
    useTutorial: Boolean(process.env.VUE_APP_USE_TUTORIAL),
    Path: serv,
    mobile: {
      iOS: process.env.VUE_APP_DOWNLOAD_IOS_MANAGER,
      Android: process.env.VUE_APP_DOWNLOAD_ANDROID_MANAGER
    },
    Sidebar: ua.device.type !== 'mobile',
    Info: {
      timezone: 'Asia/Seoul',
      timezoneOffset: '540 minutes',
      timezoneOffsetLocal: '0 minutes',
      dateFmt: 'YYYY/MM/DD'
    },
    summary: {},
    ticketSummary: {},
    license: null,
    perm: {
      isAdmin: false,
      isApprover: false,
      isSubManager: false,
      deviceMonitor: null,
      modifyInformation: null,
      useFunction: null,
      viewReport: null,
      CSRemoteControl: null,
      CSDeviceManagement: null,
      CSFileManager: null,
      CSRemoteView: null,
      CSUpdate: null,
      CSThumbnailView: null,
      CSRestart: null
    },
    isMobile: ua.device.type === 'mobile' || ua.device.type === 'tablet',
    isTablet: ua.device.type === 'tablet',
    isApplication: store.get('LMM_MOBILE_APPLICATION'),
    isCorporate: null,
    isAdmin: null,
    isApprover: null,
    isSubManager: null,
    platform: ua.device.type,
    os: ua.os.name,
    ua: ua,
    paymentState: paymentStatus,
    lang: 'ko',
    env: process.env,
    isIconView: store.get('icon_view')
  },
  methods: {
    setSummary (summ) {
      this.summary = summ
    },
    setTicketSummary (summ) {
      this.ticketSummary = summ
    }
  }
})